import { render, staticRenderFns } from "./DashboardCustomizado.vue?vue&type=template&id=9ffdce48&scoped=true"
import script from "./DashboardCustomizado.vue?vue&type=script&lang=js"
export * from "./DashboardCustomizado.vue?vue&type=script&lang=js"
import style0 from "./DashboardCustomizado.vue?vue&type=style&index=0&id=9ffdce48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffdce48",
  null
  
)

export default component.exports